export default __webpack_public_path__ + "static/media/calendar.47378674.svg";